import { Partner } from 'panel/partner/redux/types'
import { Address } from 'panel/user/address/redux/types'
import { User } from 'panel/user/redux/types'
import { AlertActionTypes } from 'util/modules/Alert/redux/types'
import { PaginationOpts } from 'util/types/index'

/**
* Data Types
*/

export type OrderPaymentType = 'MONEY'|'IN_APP'|'CARD_MACHINE'
export type OrderPaymentMethod = 'DEFAULT'|'DEBIT'|'CREDIT'

export interface OrderStatusData {
  status: string,
  payment?: {
    type: OrderPaymentType,
    method: OrderPaymentMethod
  }
}

export interface OrderStatus {
  id: number,
  order: number,
  color: string,
  name: string,
  alias: string,
  staffMessage: string,
  clientMessage: string,
  icon: string,
  roles: ('OWNER'|'MANAGER'|'DELIVERYMAN'|'COOKER'|'CLERK')[],
  createdAt: string,
  updatedAt?: string
}

export interface OrderItem {
  id: number,
  name: string,
  picture: string,
  alias: string,
  quantity: number,
  price: number,
  total: number
}

export interface OrderSection {
  id: number,
  order: number,
  name: string,
  items: OrderItem[]
}

export interface OrderProduct {
  id: number,
  partnerProductId: number,
  name: string,
  picture: string,
  quantity: number,
  price: number,
  total: number,
  annotation: string,
  sections: OrderSection[]
}

export interface OrderHistory {
  status: string,
  annotation?: string,
  createdAt: string
}
export interface OrderReview {
  id: number,
  status: 'SKIPPED'|'REVIEWED'|'APPROVED'|'REJECTED',
  points: number,
  message: string,
  createdAt: string
}

export interface Order {
  id: number,
  paymentType: OrderPaymentType,
  paymentMethod: OrderPaymentMethod,
  takeType: 'TAKE' | 'AT_PLACE' | 'DELIVERY',
  status: Partial<OrderStatus>,
  change: number,
  paymentCardTax: number,
  total: number,
  discount: number,
  distance: number,
  costDelivery: number,
  deliveryTip: number,
  deliveryDiscount: number,
  isDeliveryFree: boolean,
  isReviewed: boolean,
  isFinished: boolean,
  cashback: number,
  reviewStars: number,
  review?: OrderReview,
  address: Partial<Address>,
  partner: Partial<Partner> & { cardTaxes: { id: number, icon: string, name: string }[] },
  history: OrderHistory[],
  user: Partial<User>,
  deliverer: Partial<User>,
  products: OrderProduct[],
  createdAt: string,
  updatedAt?: string
}
/**
* State Type
*/

export interface OrderState {
  readonly order?: Order
  readonly orders: { items: Order[], pagination?: PaginationOpts }
}

/**
* Action Enum Types
*/

export enum OrderTypes {
  ORDER_GET = 'ORDER/GET',
  ORDER_LIST = 'ORDER/GET/LIST',
}

/**
* Action Types
*/
interface OrderGet {
  type: typeof OrderTypes.ORDER_GET,
  payload: Order,
  partnerId: number
}

interface OrderGetList {
  type: typeof OrderTypes.ORDER_LIST,
  payload: Order[],
  pagination?: PaginationOpts
}

export type OrderActionTypes = AlertActionTypes | OrderGet | OrderGetList
